import "./btn.css"

import React, { forwardRef } from "react"

import { BaseButton, BaseButtonElementProps } from "./BaseButton"

/**
 * @deprecated Use ButtonElementProps with loading prop instead. LoadingButton will be removed in a future version.
 */
export interface LoadingButtonProps extends BaseButtonElementProps {
  /** Whether the button is in a loading state. When true, the button is disabled and shows a loading spinner. */
  loading?: boolean
  /** Accessible label to use when the button is in loading state. */
  loadingAriaLabel?: string
}

/**
 * @deprecated Use Button with loading prop instead. LoadingButton will be removed in a future version.
 *
 * A loading button component that shows a loading indicator when the loading prop is true.
 * When loading, the button is automatically disabled and shows a spinner.
 * Supports all BaseButton props including prefix and suffix.
 *
 * @example
 * // Deprecated
 * <LoadingButton loading={true} label="Submit" />
 *
 * // Use this instead:
 * <Button loading={true} label="Submit" />
 *
 * @component
 * @see {@link https://planningcenter.github.io/tapestry/?path=/docs/deprecated-loadingbutton--docs | Storybook Documentation}
 */
export const LoadingButton = forwardRef<HTMLButtonElement, LoadingButtonProps>(
  (props, ref) => {
    return <BaseButton {...props} ref={ref} />
  }
)

LoadingButton.displayName = "LoadingButton"
